export enum ORDER_TYPE {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ORDER_COLUMN {
  STUDENT = 'STUDENT',
  TASK = 'TASK',
  LOCATION = 'LOCATION',
  GROUP = 'GROUP',
  START = 'START',
  END = 'END',
}
